<template>
    <b-container fluid>
        <b-row class="school-container-layout-result-group" id="result-group-graf">
            <b-col cols="12" class="result-group-graf-content" id="result-group-graf-content" style>
                <b-row align-h="center">
                    <b-col cols="12" class="mt-2" style="text-align: center">
                        <div class="result-group-graf-text-title">
                            Número de estudiantes que rindieron el
                            <br/>
                            <!--<div v-for="(simulacro, ind) in simulacros" :key="ind" style="float: left" class="cont-simu"-->
                            <!--v-html="simulacro.nombre">-->
                            <!--</div>-->
                            <p v-html="nombreN"></p>
                        </div>
                        <b-row align-h="center" class="pt-5 pb-5">
                            <ChartBar :chartdata="chartdataNumeroEstudiantes"/>
                        </b-row>
                    </b-col>
                    <b-col cols="12">
                        <b-row align-h="center" class="result-group-graf-background-title">
              <span
                      class="result-group-graf-text-title2"
              >Promedio de puntos obtenidos en el simulacro, por cada módulo</span>
                        </b-row>
                        <b-row align-h="center" class="pt-5 pb-5">
                            <ChartBar :chartdata="chartdataAvgSimulacro"/>
                        </b-row>
                        <b-row align-h="center">
                            <b-table-simple class="result-group-graf-table" striped hover responsive>
                                <b-thead class="result-group-graf-thead">
                                    <b-th>
                                        Teniendo en cuenta que el Simulacro de admisión 2019 - {{ simulacroPrincipal.nombre
                                        }}
                                        <br/>
                                        tiene un puntaje total de {{ simulacroPrincipal.puntajeTotal }} puntos.
                                    </b-th>
                                    <b-th>PUNTAJE</b-th>
                                </b-thead>
                                <b-tbody class="result-group-graf-tbody">
                                    <b-tr class>
                                        <td class="title-module">Mayor puntaje obtenido</td>
                                        <td>{{ simulacroPrincipal.puntajeMax }}/{{ simulacroPrincipal.puntajeTotal }}
                                        </td>
                                    </b-tr>
                                    <b-tr class>
                                        <td class="title-module">Menor puntaje obtenido</td>
                                        <td>{{ simulacroPrincipal.puntajeMin }}/{{ simulacroPrincipal.puntajeTotal }}
                                        </td>
                                    </b-tr>
                                </b-tbody>
                            </b-table-simple>
                        </b-row>
                    </b-col>
                    <b-col cols="12">
                        <b-row align-h="center" class="result-group-graf-background-title2">
              <span
                      class="result-group-graf-text-title2"
              >Promedio de puntos obtenidos en el simulacro por carrera</span>
                        </b-row>
                        <b-row align-h="center" class="pt-5 pb-5">
                            <ChartBar :chartdata="chartdataAvCarrera"/>
                        </b-row>
                    </b-col>
                    <b-col cols="12" class="mt-2">
                        <p class="result-group-graf-text-title3">
                            <span>Número de estudiantes con buen puntaje</span> VS.
                            <span>Número de estudiantes con puntaje bajo por carrera</span>
                        </p>
                        <b-row align-h="center" class="pt-5 pb-5">
                            <ChartBar :chartdata="chartdataBuenMalPts"/>
                        </b-row>
                    </b-col>
                    <b-col cols="12" class="mt-2">

                        <p class="result-group-graf-text-title3">
                            Número de estudiantes que
                            <br/>
                            <span>Completaron el simulacro</span> VS.
                            <span>no completaron el simulacro</span>
                        </p>
                        <b-row align-h="center" class="pt-5 pb-5">
                            <ChartBar :chartdata="chartdataCompletaron"/>
                        </b-row>
                    </b-col>
                    <b-col cols="12" class="mt-2" style="text-align: center">
            <span @click="imprimir()">
              <img :src="srcImagen('pdf.svg')" class="results-pdf-img" alt/>
              <a class="results-dowload">DESCARGAR RESULTADOS</a>
            </span>
                    </b-col>
                </b-row>
            </b-col>
        </b-row>
        <ModalDowload v-if="activeModal"/>
        <ModalSend :content="contentMsj" v-if="activeModalSend"/>
    </b-container>
</template>
<script>
    import ChartBar from "@/components/Global/ChartBar";
    import ModalDowload from "@/components/Global/ModalDowload";
    import ModalSend from "@/components/Global/ModalSendReturn";

    import {mapState} from "vuex";

    export default {
        name: "ResultsGroupGraf",
        components: {ChartBar, ModalDowload, ModalSend},
        data: () => ({
            contentError: {
                title: "Disculpe",
                msj: "La opcion seleccionada no tiene informacion",
                button: "Aceptar",
                icon: 2,
                back: "list-simulacros-1"
            },
            contentMsj: {},
            key: "",
            idSimulacro: "",
            simulacros: [],
            lengthSimulacro: 0,
            nombreN: "",
            simulacroPrincipal: {
                puntajeTotal: "",
                puntajeMax: "",
                puntajeMin: "",
                nombre: ""
            },
            chartdataNumeroEstudiantes: {
                scaleFontColor: "blue",
                labels: [],
                stepSize: 10,
                min: -10,
                legend: true,
                xgridLines: true,
                datasets: [
                    {
                        minBarLength: 2,
                        label: "",
                        backgroundColor: [],
                        data: [],
                        medida: " Estudiantes",
                        rotation: -360,
                        categoryPercentage: 0.6,
                        barPercentage: 0.6
                    }
                ],
                loaded: false,
                totalEstudiantes: 0
            },
            chartdataAvgSimulacro: {
                labels: [],
                stepSize: 30,
                min: -10,
                legend: false,
                xgridLines: true,
                datasets: [
                    {
                        minBarLength: 2,
                        label: "Average",
                        backgroundColor: [],
                        data: [],
                        medida: " pts",
                        rotation: -360,
                        categoryPercentage: 0.6,
                        barPercentage: 0.6
                    }
                ],
                loaded: false
            },
            chartdataAvCarrera: {
                labels: [],
                stepSize: 30,
                min: -10,
                legend: false,
                xgridLines: false,
                datasets: [
                    {
                        minBarLength: 2,
                        label: "Average",
                        backgroundColor: [],
                        data: [],
                        medida: "  Pts",
                        rotation: -90,
                        categoryPercentage: 0.6,
                        barPercentage: 0.6
                    }
                ],
                loaded: false
            },
            chartdataBuenMalPts: {
                labels: [],
                stepSize: 2,
                max: 14,
                min: -1,
                legend: true,
                xgridLines: false,
                datasets: [
                    {
                        minBarLength: 2,
                        label: "",
                        backgroundColor: "#0F376E",
                        data: [],
                        medida: "",
                        rotation: -90,
                        categoryPercentage: 0.6,
                        barPercentage: 0.6
                    },
                    {
                        minBarLength: 2,
                        label: "",
                        backgroundColor: "#ED3237",
                        data: [],
                        medida: "",
                        rotation: -90,
                        categoryPercentage: 0.6,
                        barPercentage: 0.6
                    }
                ],
                loaded: false,
                totalEstudiantes: 0
            },
            chartdataCompletaron: {
                labels: [],
                stepSize: 2,
                max: 14,
                min: -1,
                legend: true,
                xgridLines: false,
                datasets: [
                    {
                        minBarLength: 2,
                        label: "Average",
                        backgroundColor: [],
                        data: [],
                        medida: " pts",
                        rotation: -360,
                        categoryPercentage: 0.6,
                        barPercentage: 0.6
                    }
                ],
                loaded: false,
                totalEstudiantes: 0
            }
        }),
        computed: {
            ...mapState(["activeModal", "activeModalSend"])
        },
        created() {
            let keyData = JSON.parse(localStorage.getItem("keyData"));
            this.key = localStorage.getItem("keys");
            this.idSimulacro = parseInt(localStorage.getItem("id_simulacro"));
            console.log("keyData:", keyData);
            if (keyData.grado === undefined && keyData.seccion === undefined) {
                this.$store.dispatch(
                    "setModulo",
                    "RESULTADOS POR GRUPO " +
                    keyData.grado_nombre +
                    " " +
                    keyData.seccion_nombre
                );
            } else {
                this.$store.dispatch(
                    "setModulo",
                    "RESULTADOS POR GRUPO " + keyData.grado + " " + keyData.seccion
                );
            }
            this.$store.dispatch("setNav", true);
            this.getSimulacros();
            this.getMaxMinSimulacro();
            this.getNumeroEstudiante();
            this.getAvgmodulo();
            this.getAvgCarrera();
            this.getBuenMalPuntaje();
            this.getCompletaron();
        },
        mounted() {
        },
        methods: {
            goRouter(url) {
                this.$router.push(url);
            },
            srcImagen(img) {
                let src = require("@/assets/images/" + img);
                return src;
            },
            getSimulacros() {
                this.$store
                    .dispatch("getSimulacros")
                    .then(response => {
                        this.simulacros = response.data.simulacro;
                        this.lengthSimulacro = this.simulacros.length;
                        this.nombreN = "";
                        for (let i = 0; i < this.simulacros.length; i++) {
                            //                            console.log('aqui:', i, this.simulacros[i].nombre)
                            let nombre = this.simulacros[i].nombre;
                            if (this.lengthSimulacro !== i + 1) {
                                this.nombreN =
                                    this.nombreN +
                                    "<span>" +
                                    nombre +
                                    "</span>" +
                                    "<strong>" +
                                    " Vs. " +
                                    "</strong>";
                            } else {
                                this.nombreN = this.nombreN + "<span>" + nombre + "</span>";
                            }
                        }
                    })
                    .catch(error => {
                        console.log(error.message);
                    });
            },
            getMaxMinSimulacro() {
                let data = {
                    key: this.key,
                    id: this.idSimulacro
                };
                this.$store
                    .dispatch("getMaxMinSimulacro", data)
                    .then(response => {
                        //                        console.log('aqui getMaxMinSimulacro:', response)
                        let data = response.data;
                        this.simulacroPrincipal.puntajeMax = data.mayor_puntaje;
                        this.simulacroPrincipal.puntajeMin = data.menor_puntaje;
                        this.simulacroPrincipal.puntajeTotal = data.puntaje_total;
                        this.simulacroPrincipal.nombre = data.nombre;
                    })
                    .catch(error => {
                        console.log(error.message);
                    });
            },
            getNumeroEstudiante() {
                let data = {
                    key: this.key,
                    id: this.idSimulacro
                };
                this.$store
                    .dispatch("getNumeroEstudiante", data)
                    .then(response => {
                        if (response.data.length > 0) {
                            this.$store.dispatch('setNav', 'active')

                            this.$store.dispatch("setActiveModalSend", false);
                            let backgroundColor = ["#0F376E", "#5D0414"];
                            //                        console.log('aqui getNumeroEstudiante:', response.data)
                            let data = response.data;
                            let total = 0;
                            for (let i = 0; i < data.length; i++) {
                                this.chartdataNumeroEstudiantes.labels.push(data[i].nombre);
                                this.chartdataNumeroEstudiantes.datasets[0].data.push(
                                    data[i].cantidad_estudiantes
                                );
                                total = total + data[i].cantidad_estudiantes;
                                this.chartdataNumeroEstudiantes.datasets[0].backgroundColor.push(
                                    backgroundColor[i]
                                );
                            }
                            this.chartdataNumeroEstudiantes.totalEstudiantes = total;
                            this.chartdataNumeroEstudiantes.datasets[0].label =
                                "Total: " + total + " Estudiantes";
                            this.chartdataNumeroEstudiantes.loaded = true;
                            //                        console.log('aqui this.chartdataNumeroEstudiantes:', this.chartdataNumeroEstudiantes)
                        } else {
                            this.contentMsj = this.contentError;
                            this.$store.dispatch("setActiveModalSend", true);
                        }
                    })
                    .catch(error => {
                        console.log(error.message);
                    });
            },
            getAvgmodulo() {
                this.chartdataAvgSimulacro.loaded = false;
                let data = {
                    key: this.key,
                    id: this.idSimulacro
                };
                console.log("chartdataAvgSimulacro:", data);
                this.$store
                    .dispatch("getPromedioSimulacroGraf", data)
                    .then(response => {
                        let data = response.data.promedio;
                        //                        console.log('getPromedios', data)
                        for (let i = 0; i < data.length; i++) {
                            this.chartdataAvgSimulacro.labels.push(data[i].titulo);
                            this.chartdataAvgSimulacro.datasets[0].data.push(data[i].average);
                            this.chartdataAvgSimulacro.datasets[0].backgroundColor.push(
                                data[i].color
                            );
                        }
                        this.chartdataAvgSimulacro.loaded = true;
                    })
                    .catch(error => {
                        console.log(error.message);
                    });
            },
            getAvgCarrera() {
                this.chartdataAvCarrera.loaded = false;
                let data = {
                    key: this.key,
                    id: this.idSimulacro
                };
                this.$store
                    .dispatch("getAvgCarrera", data)
                    .then(response => {
                        let data = response.data;
                        //                        console.log('getAvgCarrera', data)
                        for (let i = 0; i < data.length; i++) {
                            this.chartdataAvCarrera.labels.push(data[i].nombre);
                            this.chartdataAvCarrera.datasets[0].data.push(data[i].average);
                            this.chartdataAvCarrera.datasets[0].backgroundColor.push(
                                data[i].color
                            );
                        }
                        this.chartdataAvCarrera.loaded = true;
                    })
                    .catch(error => {
                        console.log(error.message);
                    });
            },
            getBuenMalPuntaje() {
                let data = {
                    key: this.key,
                    id: this.idSimulacro
                };
                this.chartdataBuenMalPts.loaded = false;
                this.$store
                    .dispatch("getBuenMalPuntaje", data)
                    .then(response => {
                        let data = response.data;
                        //                        console.log('getBuenMalPuntaje', data)
                        let total = 0;
                        for (let i = 0; i < data.length; i++) {
                            this.chartdataBuenMalPts.labels.push(data[i].carrera);
                            this.chartdataBuenMalPts.datasets[0].data.push(data[i].aprobado);
                            this.chartdataBuenMalPts.datasets[1].data.push(data[i].reprobado);
                            total =
                                total +
                                (parseInt(data[i].aprobado, 10) +
                                    parseInt(data[i].reprobado, 10));
                        }
                        this.chartdataBuenMalPts.loaded = true;
                        this.chartdataBuenMalPts.totalEstudiantes = total;
                        this.chartdataBuenMalPts.datasets[0].label =
                            "Total: " + total + " Estudiantes";
                    })
                    .catch(error => {
                        console.log(error.message);
                    });
            },
            getCompletaron() {
                let data = {
                    key: this.key,
                    id: this.idSimulacro
                };
                this.chartdataCompletaron.loaded = false;
                this.$store
                    .dispatch("getCompletaron", data)
                    .then(response => {
                        let data = response.data;
                        console.log('getCompletaron', data)
                        let total = 0;
                        for (let i = 0; i < data.length; i++) {
                            this.chartdataCompletaron.labels.push(data[i].nombre);
                            this.chartdataCompletaron.datasets[0].data.push(data[i].total);
                            this.chartdataCompletaron.totalEstudiantes = data[i].estudiantes;
                            total = data[i].estudiantes;
                            this.chartdataCompletaron.datasets[0].backgroundColor.push(
                                data[i].color
                            );
                        }
                        this.chartdataCompletaron.loaded = true;

                        this.chartdataCompletaron.datasets[0].label =
                            "Total: " + total + " Estudiantes";
                    })
                    .catch(error => {
                        console.log(error.message);
                    });
            },
            imprimir() {
                /*asi no sale la grafica*/
                //                var contenido= document.getElementById('result-group-graf-content').innerHTML;
                //                var contenidoOriginal= document.body.innerHTML;
                //                document.body.innerHTML = contenido;
                //                window.print();
                //                document.body.innerHTML = contenidoOriginal;
                this.$store.dispatch("setActiveModal", true);
                window.print();
            }
        }
    };
</script>
